import { UseQueryResult, keepPreviousData } from '@tanstack/react-query'
import { useMemo, useState } from 'react'
import { useDebounce } from 'use-debounce'
import { z } from 'zod'

import { Category, categoryParser } from '../../models/Category'
import * as api from '../api'
import { useApiQuery } from '../useApiQuery'

export default function useCategorySuggestions(init?: string | null) {
  const [query, setQuery] = useState(init)

  const [currentQuery, debounceState] = useDebounce(query, 300)

  const result: UseQueryResult<Category[]> = useApiQuery({
    queryKey: ['categorySuggestions', currentQuery],
    placeholderData: keepPreviousData,
    queryFn: async () =>
      z
        .array(categoryParser)
        .parse((await api.get(`category?page=1&page_size=10&search=${encodeURIComponent(currentQuery || '')}`))?.data),
  })

  const suggestions = useMemo(() => result.data || [], [result.data])

  return {
    query,
    setQuery,
    suggestions,
    isFetching: result.isFetching || debounceState.isPending(),
    result,
  }
}
